'use client';

import { getLanguageFromLocale } from '@bomdisoft/translations';
import { usePieleafWebMcpAdapters } from '@pieleaf/lib/webmcp/adapters';
import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

const PIELEAF_ROUTES = {
  dataDeletion: '/data-deletion',
  home: '/',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
} as const;

/**
 * WebMCP is for agents, not for the reader's first paint. `ssr: false` keeps the
 * tool registry and its zod dependency out of the server render and out of the
 * initial JS payload; the surface attaches after hydration, which is soon enough
 * for an agent inspecting the page and invisible to a human.
 */
const WebMcpSurface = dynamic(() => import('@bomdisoft/webmcp-ui').then(ui => ui.WebMcpSurface), { ssr: false });

export const WebMcpMount = () => {
  const language = getLanguageFromLocale(useParams()?.lang as string);

  return <WebMcpSurface language={language} routes={PIELEAF_ROUTES} useAdapters={usePieleafWebMcpAdapters} />;
};
